import { useAnalytics } from "$global-providers/analytics-provider/provider";
import { differenceInDays } from "date-fns";
import { useEffect } from "react";
import type { RxDatabase } from "rxdb";
import { useLocalStorage } from "usehooks-ts";
import { RXDB_PATIENT_COLLECTION_NAME } from "../collections/patient";
import type { RxDBCollections } from "../provider";

const LAST_TIME_REPORTED_NUM_PATIENTS_KEY = "lastTimeReportedNumPatients";

export const useTrackRxdbPatients = (db: RxDatabase<RxDBCollections>) => {
  const analytics = useAnalytics();
  const [lastTimeReportedNumPatients, setLastTimeReportedNumPatients] =
    useLocalStorage(LAST_TIME_REPORTED_NUM_PATIENTS_KEY, undefined);

  useEffect(() => {
    const trackNumberOfRxDbPatients = async () => {
      if (
        db &&
        (!lastTimeReportedNumPatients ||
          differenceInDays(new Date(), new Date(lastTimeReportedNumPatients)) >=
            1)
      ) {
        const patientCount = await db[RXDB_PATIENT_COLLECTION_NAME]
          .count()
          .exec();
        analytics.trackEvent("rxdb.dailyNumberOfPatientsInRxDB", {
          numberOfPatients: patientCount,
        });
        setLastTimeReportedNumPatients(new Date().toISOString());
      }
    };
    trackNumberOfRxDbPatients();
  }, [
    lastTimeReportedNumPatients,
    setLastTimeReportedNumPatients,
    db,
    analytics.trackEvent,
    db?.[RXDB_PATIENT_COLLECTION_NAME]?.count,
  ]);
};
